import Vue from 'vue'
import Router from 'vue-router'
import { getAllRoutes } from './pages'
import { hasUserAccess } from './userUtils'
import store from '@/store'
import { UserData } from '@/generated/model/userData' // Custom function to check user access

Vue.use(Router)

let userData: UserData = {}

store.watch(
    // @ts-ignore
    (state) => state.user.userData,
    (newUser, oldUser) => {
      if (!newUser || newUser.userName === 'basic' || newUser.userName === 'operator') {
        // console.log('User logged out')
        // redirect to home page if user is logged out or does not have many permissions
        if (router.currentRoute.fullPath !== '/') {
          router.push('/')
        }
      } else {
        userData = newUser
      }
    }
)
const router = new Router({
  base: process.env.BASE_URL,
  routes: getAllRoutes(),
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.hasUserAccess) || hasUserAccess(String(to.name), userData)) {
    next()
  } else {
    next({ path: '/', query: { redirect: to.fullPath } })
  }
})

export default router
